/* Source: src/mt-includes/js/src/core/widgets/init.js*/
angular.module('website.core.widgets', [
    'website.core.animation',
    'website.core.entertainment'
]);